
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-star_d7b77fde1aa66f5c__a)"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M19.778 5.357c.04.144-.089.257-.166.345a4.191 4.191 0 0 1-.57.568c-.612.477-1.242.934-1.863 1.402-.504.38-1.012.755-1.442 1.213a5.37 5.37 0 0 0-.464.572c-.16.228-.165.469-.05.73.268.61.6 1.189.94 1.765a89.44 89.44 0 0 1 2.683 4.84c.155.305.261.633.388.95.013.033.02.069.024.104.015.174-.069.274-.246.24a1.939 1.939 0 0 1-.566-.185 24.224 24.224 0 0 1-1.238-.728c-1.312-.817-2.62-1.64-3.931-2.46-.531-.33-1.078-.637-1.667-.869-.447-.176-.909-.274-1.397-.233a3.11 3.11 0 0 0-1.045.297c-.595.273-1.13.636-1.657 1.01-1.052.75-2.095 1.512-3.146 2.264-.226.162-.465.308-.703.455a1.469 1.469 0 0 1-.3.143c-.161.055-.272-.026-.247-.187.02-.132.062-.263.113-.388.278-.666.551-1.334.845-1.993.472-1.059.963-2.11 1.437-3.166.17-.379.314-.766.402-1.172.103-.471-.036-.845-.459-1.108-.236-.148-.488-.273-.735-.405-.176-.094-.356-.18-.531-.275a2.458 2.458 0 0 1-.28-.176c-.282-.206-.267-.454.055-.593.366-.158.742-.298 1.122-.424.584-.194 1.176-.366 1.763-.555.218-.07.43-.16.645-.24.553-.21.99-.562 1.308-1.032.316-.465.591-.954.892-1.428.142-.224.287-.45.46-.653.099-.117.244-.212.388-.275.274-.12.47-.065.651.162.117.147.214.308.314.466.185.292.36.59.549.879.17.26.422.425.737.48.204.036.418.066.622.047a49.108 49.108 0 0 0 1.955-.224c1.02-.138 2.035-.298 3.055-.431.279-.036.567-.022.85-.012a.85.85 0 0 1 .34.091.307.307 0 0 1 .165.19z",
  stroke: "#423F45",
  strokeWidth: 2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-star_d7b77fde1aa66f5c__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(2 2.54)",
  d: "M0 0h20v20H0z"
})))));

      const __svgRaw = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g clip-path=\"url(#jihn0cw3ja)\">\r\n        <path clip-rule=\"evenodd\" d=\"M19.778 5.357c.04.144-.089.257-.166.345-.176.201-.358.404-.57.568-.612.477-1.242.934-1.863 1.402-.504.38-1.012.755-1.442 1.213-.168.18-.324.373-.464.572-.16.228-.165.469-.05.73.268.61.6 1.189.94 1.765a89.44 89.44 0 0 1 2.683 4.84c.155.305.261.633.388.95.013.033.02.069.024.104.015.174-.069.274-.246.24a1.939 1.939 0 0 1-.566-.185 24.224 24.224 0 0 1-1.238-.728c-1.312-.817-2.62-1.64-3.931-2.46-.531-.33-1.078-.637-1.667-.869-.447-.176-.909-.274-1.397-.233a3.11 3.11 0 0 0-1.045.297c-.595.273-1.13.636-1.657 1.01-1.052.75-2.095 1.512-3.146 2.264-.226.162-.465.308-.703.455a1.469 1.469 0 0 1-.3.143c-.161.055-.272-.026-.247-.187.02-.132.062-.263.113-.388.278-.666.551-1.334.845-1.993.472-1.059.963-2.11 1.437-3.166.17-.379.314-.766.402-1.172.103-.471-.036-.845-.459-1.108-.236-.148-.488-.273-.735-.405-.176-.094-.356-.18-.531-.275a2.458 2.458 0 0 1-.28-.176c-.282-.206-.267-.454.055-.593.366-.158.742-.298 1.122-.424.584-.194 1.176-.366 1.763-.555.218-.07.43-.16.645-.24.553-.21.99-.562 1.308-1.032.316-.465.591-.954.892-1.428.142-.224.287-.45.46-.653.099-.117.244-.212.388-.275.274-.12.47-.065.651.162.117.147.214.308.314.466.185.292.36.59.549.879.17.26.422.425.737.48.204.036.418.066.622.047.653-.061 1.306-.137 1.955-.224 1.02-.138 2.035-.298 3.055-.431.279-.036.567-.022.85-.012a.85.85 0 0 1 .34.091c.068.034.139.095.165.19z\" stroke=\"#423F45\" stroke-width=\"2\"/>\r\n    </g>\r\n    <defs>\r\n        <clipPath id=\"jihn0cw3ja\">\r\n            <path fill=\"#fff\" transform=\"translate(2 2.54)\" d=\"M0 0h20v20H0z\"/>\r\n        </clipPath>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-star.d7b77fde1aa66f5c9aa002113c47f37e.svg"),
        {
          React: SvgIconStar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      